export type TicketStatus = "classified" | "no-po" | "excluded";

export type Ticket = {
  id: string;
  supplier: string;
  summary: string;
  raised: string;
  priority: "High" | "Medium" | "Low";
  value: string;
  classification: string;
  confidence?: string;
  status: TicketStatus;
  category: string;
};

export const ARCHETYPES = [
  { cluster: "M1", archetype: "Unit price variance", share: "34%", rootCause: "Contract / price-list version drift", confidence: "96%", tone: "good" },
  { cluster: "M2", archetype: "Quantity or partial receipt", share: "23%", rootCause: "GRN incomplete at invoice time", confidence: "94%", tone: "good" },
  { cluster: "M3", archetype: "Tax code / UoM mismatch", share: "15%", rootCause: "Master data inconsistency", confidence: "92%", tone: "good" },
  { cluster: "M4", archetype: "Wrong or missing PO reference", share: "12%", rootCause: "Supplier quoted the wrong PO", confidence: "74%", tone: "warn" },
  { cluster: "M5", archetype: "Freight & surcharge not on PO", share: "9%", rootCause: "Uncontracted add-on lines", confidence: "88%", tone: "warn" },
  { cluster: "M6", archetype: "Duplicate invoice", share: "7%", rootCause: "Resubmission after a chaser", confidence: "97%", tone: "good" },
] as const;

export const SOURCE_BARS = [
  { label: "Top 10 suppliers", value: "46%" },
  { label: "Recurring monthly", value: "38%" },
  { label: "Long tail", value: "54%" },
  { label: "First occurrence", value: "62%" },
];

export const BEFORE_AFTER = [
  { measure: "Average ticket handling time", today: "22 min", withAgent: "4 min", delta: "-82%" },
  { measure: "Tickets resolved on first touch", today: "54%", withAgent: "91%", delta: "+37 pts" },
  { measure: "Invoices blocked > 7 days", today: "18%", withAgent: "5%", delta: "-13 pts" },
  { measure: "Over-billing recovered", today: "$0.9M / yr", withAgent: "$2.4M / yr", delta: "+$1.5M" },
  { measure: "Recurring mismatch volume", today: "baseline", withAgent: "-31%", delta: "prevention loop" },
];

export const WORKFLOW_STEPS = ["Ticket intake", "Ariba API pull", "Receipt & contract check", "Mismatch diagnosis", "Resolution drafting"];